export default {
  "content": "<path fill=\"#333\" d=\"M0 0l5 5 5-5H0z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "10",
    "height": "5",
    "fill": "none",
    "viewBox": "0 0 10 5"
  }
};